import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useMobileNavigate } from './MobileNavigationGuard';
import { resolveMobileDestination } from './navigation';

import { Button } from '../ui/button';

export function MobileUnsupportedScreen() {
  const navigate = useMobileNavigate();
  const desktop = resolveMobileDestination(useLocation().pathname) === 'desktop';

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 text-center text-sm text-muted-foreground">
      <div className="flex flex-col items-center gap-3">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-full tone-amber-soft">
          <AlertTriangle className="h-5 w-5" />
        </span>
        <div className="space-y-1">
          <h2 className="text-lg font-semibold text-foreground">{desktop ? 'Desktop feature' : 'Page unavailable'}</h2>
          <p>{desktop ? 'This feature is available on desktop. Choose a mobile workspace to continue.' : 'This address does not match an available mobile page.'}</p>
        </div>
      </div>
      <Button size="sm" className="min-h-11 whitespace-normal" onClick={() => navigate('/')}>Return to dashboard</Button>
    </div>
  );
}
